import { createSlice } from '@reduxjs/toolkit';

export const sessionControl = createSlice({
    name:"sessionControl",
    initialState:{
        userSessionControl: null,
        photoUser: null
    },
    reducers:{
        login: (state,action) =>{
            state.userSessionControl = action.payload;
        },
        logout : (state) => {
            state.userSessionControl = null;
            state.photoUser = null;
        },
        setPhotoUser: (state,action) =>{
            state.photoUser = action.payload;
        },
    },
});

export const {login,logout,setPhotoUser} = sessionControl.actions;

export const selectUserSessionControl = (state) => state.userSessionControl.userSessionControl;

export default sessionControl.reducer;